import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#1a0f00] py-12 px-4" data-id="element-201">
      <div className="max-w-5xl mx-auto" data-id="element-202">
        <h2 className="text-2xl sm:text-3xl font-black text-white text-center mb-8" data-id="element-203">
          📊 LOS NÚMEROS QUE RESPALDAN EL SISTEMA
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-204">
          <div data-id="element-205">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-206">
              +500
            </div>
            <div className="text-[#F97316] text-sm font-semibold mt-1" data-id="element-207">
              entrenadores confían
            </div>
          </div>
          <div data-id="element-208">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-209">
              6+6
            </div>
            <div className="text-[#F97316] text-sm font-semibold mt-1" data-id="element-210">
              Tomos + Bonos
            </div>
          </div>
          <div data-id="element-211">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-212">
              4.9/5
            </div>
            <div className="text-[#F97316] text-sm font-semibold mt-1" data-id="element-213">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-214">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-215">🌎</div>
            <div className="text-[#F97316] text-sm font-semibold mt-1" data-id="element-216">
              Disponible en todo el mundo hispanohablante
            </div>
          </div>
        </div>

        <h3 className="text-xl sm:text-2xl font-black text-white text-center mb-6 mt-12" data-id="element-217">
          ⭐ LO QUE DICEN LOS QUE YA LO TIENEN
        </h3>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-218">
          <div className="flex items-start gap-3 bg-black/40 border border-[#F97316]/20 rounded-xl p-4" data-id="element-219">
            <div className="w-10 h-10 rounded-full bg-[#F97316]/20 flex items-center justify-center text-[#F97316] font-black text-sm flex-shrink-0" data-id="element-220">
              MR
            </div>
            <div data-id="element-221">
              <div className="text-[#F97316] text-xs mb-1" data-id="element-222">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-223">
                "Organicé todo el año en una tarde. Ahora tengo cada clase
                pensada y secuenciada para todos mis grupos. Nunca más llego al
                gimnasio sin saber qué voy a dar."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-224">
                — Marcos R., Buenos Aires | Entrenador de Gimnasio de Barrio
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#F97316]/20 rounded-xl p-4" data-id="element-225">
            <div className="w-10 h-10 rounded-full bg-[#F97316]/20 flex items-center justify-center text-[#F97316] font-black text-sm flex-shrink-0" data-id="element-226">
              JG
            </div>
            <div data-id="element-227">
              <div className="text-[#F97316] text-xs mb-1" data-id="element-228">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-229">
                "Las clases con progresión real bimestral cambiaron todo. Mis
                alumnos intermedios mejoraron más en 2 meses que en todo el año
                anterior. El sistema de potencia del Tomo 3 es único."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-230">
                — Jorge G., Rosario | Instructor de Boxeo Recreativo
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#F97316]/20 rounded-xl p-4" data-id="element-231">
            <div className="w-10 h-10 rounded-full bg-[#F97316]/20 flex items-center justify-center text-[#F97316] font-black text-sm flex-shrink-0" data-id="element-232">
              SV
            </div>
            <div data-id="element-233">
              <div className="text-[#F97316] text-xs mb-1" data-id="element-234">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-235">
                "Adapto la misma clase a 3 niveles distintos en 5 minutos. Antes
                me llevaba horas inventar qué hacer. Con el Método 3 Carriles
                del Bono 1, todos trabajan al mismo tiempo."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-236">
                — Sofía V., Córdoba | Profesora de Educación Física
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}